import { PaperClipIcon } from '@heroicons/react/20/solid'
import { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const FileUpload = ({
    setParent,
    setUrlVal,
    setOpen,
    updateParent = null,
    previousFiles = []
}) => {
    const [pfiles, setPfiles] = useState(previousFiles);
    const [fileDataArray, setFileDataArray] = useState([]);
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        maxSize: 6000*1024, 
        minSize: 10*1024, 
        accept: {
            'image/png': ['.png'],
            'image/jpg': ['.jpg'],
            'image/jpeg': ['.jpeg'],
            'application/pdf': ['.pdf'],
        },
    });
    const files = acceptedFiles.map((file,index) => (
        <li key={file.path} className="justify-between flex py-1 text-sm  text-gray-800">
            <p>{file.path} - {file.size} bytes</p>
            {/* <p onClick={() => { setUrlVal(fileDataArray[index].data); setOpen(true);}} className="inline-block cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                View
            </p> */}
        </li>
    ));

    useEffect(() => {
        if(acceptedFiles.length){
            Promise.all(
                Array.from(acceptedFiles).map((file) => {
                  return new Promise((resolve) => {
                    const reader = new FileReader();
        
                    reader.onload = (e) => {
                      resolve({
                        name: file.name,
                        data: e.target.result,
                      });
                    };
        
                    reader.readAsDataURL(file);
                  });
                })
            ).then((fileDataAsArray) => {
                // Set the file data array in the same order as selected
                setFileDataArray(fileDataAsArray);
            });
        }
        if (acceptedFiles.length > 0 && (acceptedFiles[0]?.size / 1024) < 6000 && (acceptedFiles[0]?.size / 1024) > 10)
            setParent(acceptedFiles);
    }, [acceptedFiles]);
    return (
        <>
            <div
                {...getRootProps({ className: 'dropzone' })}
                className="relative block w-full cursor-pointer rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
                <input {...getInputProps()} />
                <span className="mt-2 block text-sm font-medium text-gray-900">
                    Drag and drop your files (pdf, png, jpg, jpeg) here, or <span className="text-blue-600 hover:text-blue-500">browse</span> (Max size 6 MB)
                </span>
            </div>
            <aside className='mt-4'>
                <h4 className="text-sm font-medium text-gray-500 pb-4">Files</h4>
                <ul role="list" className="-my-5 divide-y divide-gray-200">
                    {files}
                </ul>
            </aside>
            {pfiles.length > 0 &&
                <aside className='mt-4'>
                    <h4 className="text-sm font-medium text-gray-500 pb-4">
                        Previously uploaded files
                    </h4>
                    <ul role="list" className="divide-y divide-gray-200 rounded-md border border-gray-200">
                        {pfiles && pfiles.map((contract, index) => (
                            <li className="flex items-center justify-between py-3 pl-3 pr-4 text-sm">
                                <div className="flex w-0 flex-1 items-center">
                                    <PaperClipIcon className="h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                    <span className="ml-2 w-0 flex-1 truncate">
                                        {contract.split("/").pop()}
                                    </span>
                                </div>
                                <div className="ml-4 flex-shrink-0">
                                    <p onClick={() => { setUrlVal(contract); setOpen(true);}} className="inline-block cursor-pointer font-medium text-blue-600 hover:text-blue-500">
                                        View
                                    </p>
                                    <a href={contract} target="_blank" className="ml-2 font-medium text-indigo-600 hover:text-indigo-500">
                                        Download
                                    </a>
                                    <button
                                        type="button"
                                        className="ml-2 font-medium text-red-600 hover:text-red-500"
                                        onClick={() => {
                                            const newFiles = pfiles.filter((file, i) => i !== index);
                                            setPfiles(newFiles);
                                            updateParent(newFiles);
                                        }}
                                    >
                                        Delete
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </aside>
            }
        </>
    );
}

export default FileUpload;